import { Box3, Vector3 } from "three";
import { PointCloudFactory } from "../PointCloud";
import { IPointCloudTile } from "../PointCloudTile";
import { BVHLoader } from "./BVHLoader";

export enum PointCloudType {
  LAS = 0,
  PLY = 1,
  STREAM = 2,
  STREAM_BIN = 3
}

export enum FileType {
  POINTCLOUD,
  BVH,
}

export interface IPointCloudLoadParams {
  version: number;
  url: string | {baseKey: string, bucket: string};
  type: PointCloudType;
  gridSize?: number;
}

export interface IPointCloudLoaderDependencies {
  pointCloudFactory: PointCloudFactory;
}

export interface IPointCloudTileGeometry {
  vertices: Float32Array;
  color: Float32Array;
  indices?: Uint8Array;
  offset?: Vector3;
  bbox?: Box3;
}

export interface IPointCloudLoader {
  load(
    params: IPointCloudLoadParams,
    abortController: AbortController
  ): Promise<IPointCloudTileGeometry>;
}

export interface IBVHLoader {
  load(
    params: IPointCloudLoadParams,
    abortController: AbortController
  ): Promise<{root: IPointCloudTile, offset:number[]}>;
}

export type TLoader = IPointCloudLoader | BVHLoader;